import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { IconButton, type Size } from '../../app-core/lib/ui/IconButton'
import type { IconName } from './helpers/icons'

enum Events {
    onClick = 'on-click',
}

@customElement('zaptic-icon-button')
export class IconButtonWrapper extends LitElement {
    @property({ attribute: 'icon-name' })
    iconName: IconName

    @property({ attribute: 'size' })
    size: Size

    @property({ attribute: 'tooltip' })
    tooltip?: string

    @property({ attribute: 'disabled' })
    disabled?: boolean

    @property({ attribute: 'no-border' })
    noBorder?: boolean

    onClick = () => {
        this.dispatchEvent(new CustomEvent(Events.onClick, { composed: true }))
    }

    render() {
        return ReactDOM.render(
            <IconButton
                id={this.id}
                iconName={this.iconName}
                size={this.size}
                tooltip={this.tooltip}
                disabled={this.disabled}
                border={!this.noBorder}
                onClick={this.onClick}
            />,
            this
        )
    }

    protected createRenderRoot() {
        return this
    }
}
